import { useEffect, useState } from "react";

// How long after coming back to the tab before a still-broken connection is reported.
const GRACE_MS = 5000;

// The "lost connection" banner waits while the tab is in the background (browsers slow the live connection's checks
// there, so it often drops and recovers on its own) and for a few seconds after coming back, so the quiet reconnect
// does not flash it. A connection that is still down after that is shown as before.
export const useConnectionBannerAllowed = () => {
    const [allowed, setAllowed] = useState<boolean>(() => document.visibilityState === "visible");

    useEffect(() => {
        let graceTimeout: ReturnType<typeof setTimeout> | undefined;

        const onVisibilityChange = () => {
            clearTimeout(graceTimeout);
            if (document.visibilityState !== "visible") setAllowed(false);
            else graceTimeout = setTimeout(() => setAllowed(true), GRACE_MS);
        };

        document.addEventListener("visibilitychange", onVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", onVisibilityChange);
            clearTimeout(graceTimeout);
        };
    }, []);

    return allowed;
};
